import { memo } from "react";

function APTPlusDeliveryStopMarker({ stopNo, backgroundColor, textColor }) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -2;
  return (
    <svg
      width="30"
      height="29"
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.5 7C29.5 10.5899 26.5899 13.5 23 13.5C19.4101 13.5 16.5 10.5899 16.5 7C16.5 3.41015 19.4101 0.5 23 0.5C26.5899 0.5 29.5 3.41015 29.5 7ZM14.5 8.7002C14.5 12.1218 17.1438 14.9259 20.5 15.1813V24.7002C20.5 26.6332 18.933 28.2002 17 28.2002H4C2.067 28.2002 0.5 26.6332 0.5 24.7002V11.7002C0.5 9.7672 2.067 8.2002 4 8.2002H14.519C14.5064 8.36529 14.5 8.53203 14.5 8.7002Z"
        fill={backgroundColor}
        stroke={textColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.24659 16.6514C7.17393 17.0964 7.41752 17.9417 7.76229 18.727C8.07989 19.4504 8.54794 20.1391 9.17685 20.7682L9.21716 20.8089C10.5321 22.1233 11.7629 22.761 13.3887 22.7668C13.4859 22.6862 14.0244 22.259 14.2397 21.703C14.2351 21.6997 14.2189 21.649 14.2015 21.6082C14.1252 21.6082 13.3887 21.3323 13.156 21.3119C13.156 21.3119 12.9229 21.7938 12.585 22.053C12.247 22.3121 11.3192 21.8938 10.8234 21.531C10.4045 21.2268 9.90971 20.8745 9.50742 20.4789C9.10845 20.0729 8.8348 19.6691 8.52602 19.246C8.32238 18.9672 7.89912 18.3138 7.98693 17.7543C8.07474 17.1948 8.91583 16.8886 8.91417 16.8633C8.73131 16.1834 8.73963 16.3465 8.52602 15.7489C8.49028 15.736 8.44498 15.7252 8.41298 15.7252C8.01794 15.9321 7.31925 16.2064 7.24659 16.6514ZM13.8897 24C11.9726 24 9.99094 23.1171 8.45184 21.5786L8.42127 21.5458C6.82535 19.9367 5.95528 17.9156 6.00177 15.9664L6.00522 15.8226L6.09433 15.7099C6.2321 15.5347 6.36814 15.3801 6.51107 15.2376C7.03329 14.7155 7.64721 14.316 8.33603 14.0491C8.41955 14.0168 8.51427 14 8.61673 14C8.84878 14 9.37056 14.118 9.50402 14.4834C9.73908 15.136 10.0357 15.9875 10.2514 16.802C10.3112 17.0306 10.2527 17.5829 9.93325 17.7843L9.17209 18.2669C9.17898 18.2729 9.17554 18.3917 9.27456 18.5273C9.56989 18.932 9.91215 19.3323 10.291 19.718C10.6729 20.093 11.072 20.4331 11.4732 20.7249C11.5516 20.7822 11.6398 20.8153 11.7113 20.8153L11.9748 20.4477L12.2171 20.0659C12.4281 19.7387 12.9563 19.7292 13.0157 19.7292C13.0773 19.7292 13.132 19.7348 13.1828 19.746C14.1855 19.9699 14.7822 20.1623 15.5476 20.5093C15.8877 20.6625 16.1025 21.2794 15.9501 21.6664C15.6849 22.353 15.2854 22.9669 14.7645 23.489C14.6168 23.6358 14.4575 23.7762 14.2896 23.907L14.1773 23.9953L13.8897 24Z"
        fill={textColor}
      />
      <path
        d="M3.5 20C4.32843 20 5 19.3284 5 18.5C5 17.6716 4.32843 17 3.5 17C2.67157 17 2 17.6716 2 18.5C2 19.3284 2.67157 20 3.5 20Z"
        fill={textColor}
      />
      <path
        d="M17.5 20C18.3284 20 19 19.3284 19 18.5C19 17.6716 18.3284 17 17.5 17C16.6716 17 16 17.6716 16 18.5C16 19.3284 16.6716 20 17.5 20Z"
        fill={textColor}
      />
      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={textColor}
      >
        <tspan x={21 + shiftLeft} y={10.5}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(APTPlusDeliveryStopMarker);
